import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { NSGridModule } from '@norfolk-southern/accessns-components';

import { ReservationsComponent } from '@ruby/modules/reservations/component/reservations.component';
import { ReservationsContainer } from '@ruby/modules/reservations/container/reservations.container';
import { ReservationsRoutingModule } from '@ruby/modules/reservations/reservations-routing.module';
import { fromReservations, ReservationsEffects } from '@ruby/modules/reservations/store';
import { DirectivesModule } from '@ruby/shared/directives/directives.module';
import { GridPreferencesCustomService } from '@ruby/shared/services/grid-preferences-custom.service';

@NgModule({
  declarations: [ReservationsComponent, ReservationsContainer],
  imports: [
    CommonModule,
    DirectivesModule,
    EffectsModule.forFeature([ReservationsEffects]),
    FormsModule,
    ReactiveFormsModule,
    NSGridModule.forRoot(GridPreferencesCustomService),
    ReservationsRoutingModule,
    StoreModule.forFeature(fromReservations.featureKey, fromReservations.reducer)
  ],
  exports: [ReservationsContainer]
})
export class ReservationsModule {}
